import '@mui/lab/themeAugmentation'
import { createTheme as createMuiTheme } from '@mui/material/styles'
import breakpoints from './breakpoints'
import components from './components'
import typography from './typography'
import variants from './variants'
import { fiFI, svSE, enUS } from '@mui/x-data-grid/locales'
import { fiFI as coreFiFI, svSE as coreSvSE, enUS as coreEnUS } from '@mui/material/locale'
import Language from '../enums/Language'
import { Localization as MuiLocalization } from '@mui/material/locale'
import { Localization as MuiDataGridLocalization } from '@mui/x-data-grid/utils/getGridLocalization'

const createTheme = (name: string, language?: Language) => {
  /**
   * Get the theme localizations.
   *
   * @see https://mui.com/material-ui/guides/localization/
   * @see https://mui.com/x/react-data-grid/localization/
   */
  const getLocalizations = (): Array<MuiLocalization | MuiDataGridLocalization> => {
    switch (language) {
      case 'fi':
        return [fiFI, coreFiFI]
      case 'swe':
        return [svSE, coreSvSE]
      case 'en':
      default:
        return [enUS, coreEnUS]
    }
  }

  let variant = variants.find((variant) => variant.name === name)

  if (!variant) {
    console.warn(new Error(`The theme ${name} is not valid`))
    variant = variants[0]
  }

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints: breakpoints,
      components: components,
      typography: typography,
      // shadows: shadows,
      palette: variant.palette
    },
    {
      name: variant.name,
      header: variant.header,
      footer: variant.footer,
      sidebar: variant.sidebar
    },
    ...getLocalizations()
  )
}

export default createTheme
